import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

export enum WorkOrderUnsavedChangesDialogResult {
  NONE,
  CONTINUE_EDITING,
  DISCARD_CHANGES,
}

@Component({
  selector: 'work-order-unsaved-changes-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './work-order-unsaved-changes-dialog.component.html',
  styleUrls: ['./work-order-unsaved-changes-dialog.component.scss'],
})
export class WorkOrderUnsavedChangesDialogComponent {
  WorkOrderUnsavedChangesDialogResult = WorkOrderUnsavedChangesDialogResult;

  constructor(public dialogRef: MatDialogRef<WorkOrderUnsavedChangesDialogComponent>) {}

  continueEditing() {
    this.dialogRef.close(WorkOrderUnsavedChangesDialogResult.CONTINUE_EDITING);
  }
}
